// Carriers whose booked shipments can be cancelled from the app
const DELETABLE_CARRIER_TYPES = ['dhl_parcel_de']

const is_today = (date) => {
  if(!date) return false
  const d = new Date(date)
  const now = new Date()
  return d.getFullYear() === now.getFullYear()
    && d.getMonth() === now.getMonth()
    && d.getDate() === now.getDate()
}

// A label can only be deleted while it is new: the carrier must support cancelling
// shipments and the label has to be created today (DHL closes the day at manifest).
export const is_label_deletable = ({ carrier, tracking_number, created_at }) => {
  if(!carrier || !DELETABLE_CARRIER_TYPES.includes(carrier.type)) return false
  if(!tracking_number) return false
  return is_today(created_at)
}
